/**
 * NOIRE_ARCHETYPE
 *
 * The "Ground Truth" statistical profile for Film Noire / Dark Jazz.
 * Traits:
 * - Slow Harmonic Rhythm (Langourous)
 * - Walking Bass (Steady low-end pulse)
 * - "Smoky" Voice Distribution (Mid-range Sax/Trumpet + Low Bass)
 * - High Swing (Rhythmic Lock)
 */

import { SLOW_ARCHETYPE } from './BaseArchetype.js';

export const NOIRE_ARCHETYPE = {
    ...SLOW_ARCHETYPE,

    // Harmonic Rhythm: Slow.
    // Chords linger to set the mood.
    harmonicRhythm: {
        ...SLOW_ARCHETYPE.harmonicRhythm,
        target: 4.0, // 1 chord every 4 bars (or very slow changes)
        tolerance: 2.0
    },

    // Voice Distribution: Bottom heavy + Soloist.
    // Deep Bass (Walking) + Mid/High Soloist (Sax/Trumpet).
    voiceDistribution: {
        ...SLOW_ARCHETYPE.voiceDistribution,
        low: 0.40, // Walking Bass prominence
        mid: 0.40, // Piano Comping / Sax
        high: 0.20, // Occasional high hits, but mostly mid-focused
        tolerance: 0.20
    },

    // Dynamic Range: Expressive/Swells.
    // Not wall-of-sound, but highly dynamic solo lines.
    dynamicRange: {
        ...SLOW_ARCHETYPE.dynamicRange,
        minVariance: 0.15,
        targetVariance: 0.30,
        dynamicShape: 'swell'
    },

    // Interval Entropy: Bluesy/Lyrical.
    // Mix of steps and blues leaps.
    intervalEntropy: {
        ...SLOW_ARCHETYPE.intervalEntropy,
        stepRatio: 0.60,
        tolerance: 0.20
    },

    // Rhythmic Lock: Critical (Swing).
    // Bass and Drums must lock.
    rhythmicLock: {
        ...SLOW_ARCHETYPE.rhythmicLock,
        target: 0.85,
        weight: 0.3
    }
};
